import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CategoryService } from 'src/app/_services/category.service';
import { AlertService } from 'src/app/_services/alert.service';
import { User } from 'src/app/_models';
import { DocumentService } from 'src/app/_services/document.services';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { JsonEditorOptions } from 'ang-jsoneditor';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, NgForm } from '@angular/forms';
import { element } from 'protractor';
import { AppConfig } from 'src/assets/config/config/app-config';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dialog-uploadfile',
  templateUrl: './dialog-uploadfile.component.html',
  styleUrls: ['./dialog-uploadfile.component.scss'],
  providers: [DatePipe]
})
export class DialogUploadfileComponent implements OnInit {

 

  @Input() categoryId: any;
  @Input() fileToUpload: File = null;
  @Output() openUpload = new EventEmitter<boolean>();
  @ViewChild('initiateForm') initiateForm: NgForm;

  category: any;
  azureHeader = {};
  documentTitle: string = null;
  docId: String = null;
  properties = {};
  uploadMessage: Boolean = false;
  toggleUpload: Boolean = true;
  currentUser: User;
  isWorkflow: boolean = false;
  workflowID: any;
  filePath: string = null
  valuesForm: FormGroup
  multiparts: any[]
  source: string = this.config.getConfig("source");
  isError = false;
  errorMessage = '';
  hideFields = ["SF Application ID", "Reason for Delete", "Digitization User Info", "Portal User Info", "Reference Entities", "Source", "Legacy Folder ID", "Batch ID", "Parent Doc ID", "Parent", "Deletion Requested By", "Deletion Requested Date"];

  constructor(
    private categorySvc: CategoryService,
    private documentService: DocumentService,
    private alertService: AlertService,
    //@Inject(MAT_DIALOG_DATA) public data: any
    private authenticationService: AuthenticationService,
    private config: AppConfig,    
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    
    this.currentUser = this.authenticationService.currentUserValue;
  }

  getData(data, index) {
    this.category.meta_data_definition.properties[index].value = data;    
  }

  ngOnInit(): void {
    if (this.fileToUpload.type.includes('pdf') || this.fileToUpload.type.includes('image')) {
      this.filePath = (window.URL || window.webkitURL).createObjectURL(this.fileToUpload)
      console.log("change")
    }
    var strArrayAttributes = []
    this.categorySvc.get(this.categoryId)
      .subscribe(category => {
        category.meta_data_definition.properties.forEach(element => {
          if (!this.hideFields.includes(element.name)) {
            if (element.data_type == 'str array') {
              strArrayAttributes.push(element.name)
            }
          }
          if (element.name === 'Source') {
            element.value = this.source;
          }
          if (element.name === 'Ownership') {
            element.value = "Records";
          }
          if (this.hideFields.includes(element.name)) {
            element["isHide"] = true
          } else {
            element["isHide"] = false
          }
        })
        if (strArrayAttributes.length > 0) {
          this.createValuesForm(strArrayAttributes)
        }
        this.category = category;
      })
  }

  updateList(values, property, event: any) {
    const currentDate = event.target.value;
    if (property.name == "Key Date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');
        let dateStrFormat = dateString.split("-");
        values.forEach(obj => {
          if (obj.name == "Key Year") {
            obj.value = dateStrFormat[0];
          }
          if (obj.name == "Key Date") {
            obj.value = dateString;            
          }
        });      
        property['isError'] = false;
        this.initiateForm.controls[property.name].setErrors(null);
      } else {
        property['isError'] = true;
        this.initiateForm.controls[property.name].setErrors({'isError': true});
      }
    }
    if (property.data_type == "date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
        values.forEach(obj => {
          if (obj.name == property.name) {
            obj.value = dateString;
          }         
        });
        property['isError'] = false;
        this.initiateForm.controls[property.name].setErrors(null);
      } else {
        property['isError'] = true;
        this.initiateForm.controls[property.name].setErrors({'isError': true});
      }
    }
  }

  createValuesForm(properties) {
    var formControlObject = {}
    properties.forEach(property => {
      formControlObject[property] = new FormArray([this.initValues()])
    });
    this.valuesForm = new FormGroup(
      formControlObject
    )
  }

  initValues() {
    return new FormGroup({
      value: new FormControl('', Validators.required)
    })
  }

  addNewValue(property) {
    const control = <FormArray>this.valuesForm.get(property);
    control.push(this.initValues());
  }

  getValues(form, property) {
    return form.controls[property].controls;
  }

  deleteForm(index: number, property) {
    this.valuesArray(property).removeAt(index);
  }

  valuesArray(property) {
    return <FormArray>this.valuesForm.get(property)
  }

  async uploadDocument() {
    this.isError = false;
    this.errorMessage = '';
    var systemProperties = null;
    if (this.fileToUpload) {
      systemProperties = {
        "fileName": this.fileToUpload.name,
        "lastModifiedDate": new Date(this.fileToUpload.lastModified),
        "size": String(this.fileToUpload.size),
        "type": this.fileToUpload.type
      }
    }
    //build object to be sent to the service
    var uploadReq = {
      "title": this.documentTitle,
      "category_id": this.category.id,
      "meta_data": {},
      "system_properties": systemProperties
    }
    //populate meta-data
    this.category.meta_data_definition.properties.forEach(obj => {
      if (obj.data_type === "int") {
        this.properties[obj.name] = parseInt(obj.value);
      }
      else if (obj.data_type === "date") {
        if (obj.value == '' || obj.value == null) {
          this.properties[obj.name] = undefined
        } else {
          const editField = new Date(obj.value);          
          let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');          
          this.properties[obj.name] = dateString;
        }
      }
      else if (obj.data_type === "str") {
        if (obj.value == '' || obj.value == null) {
          this.properties[obj.name] = undefined
        }
        else {
          this.properties[obj.name] = obj.value
        }
      }
      else if (obj.data_type == "bool") {
        this.properties[obj.name] = false
        if (obj.value) {
          this.properties[obj.name] = obj.value
        }
      }
      else if (obj.data_type == "str array") {
        var values = []
        if (!this.hideFields.includes(obj.name)) {
          if (this.valuesForm.value[obj.name].length == 0 || this.valuesForm.value[obj.name] == null) {
            this.properties[obj.name] = undefined
          }
          else {
            this.valuesForm.value[obj.name].forEach(element => {
              values.push(element.value)
            });
            this.properties[obj.name] = values
          }
        }
      }
      else {
        this.properties[obj.name] = obj.value;
      }
    })
    uploadReq.meta_data = this.properties;
    // console.log(this.fileToUpload.size, (this.fileToUpload.size / 5))
    // const noOfParts = 5
    // const chunkSize = (this.fileToUpload.size / noOfParts)

    // for (let start = 0; start < this.fileToUpload.size; start += chunkSize) {
    //   const chunk = this.fileToUpload.slice(start, start + chunkSize + 1)
    //   console.log("chunk", chunk)
    // }
    let isValid = await this.validData();
    if (!isValid) {
      this.isError = true;
      this.errorMessage = 'Placeholder UUID is invalid, please correct the data';
      return;
    } else {
      
      this.properties["Portal User Info"] = {"reviewedBy": ""};
      console.log("metadata list", this.properties);
      let formData = new FormData();
      formData.append("title", this.documentTitle)
      formData.append("category_id", this.categoryId)
      formData.append("meta_data", JSON.stringify(this.properties))    
      formData.append("file", this.fileToUpload)
      this.documentService.uploadDocumentDirect(formData).subscribe((resp: any) => {

        // Check if Water Right ID exists and is valid, then update water right reference
        const waterRightId = this.properties['Water Right ID'];
        if (waterRightId && Array.isArray(waterRightId) && waterRightId.length > 0) {
          this.documentService.updateWaterRightReference(resp.docId)
            .subscribe(
              updateResp => {
                console.log('Water Right reference updated successfully for document:', resp.docId);
              },
              updateError => {
                console.error('Failed to update Water Right reference for document:', resp.docId, updateError);
              }
            );
        }
        //reset form
        this.documentTitle = null;
        for (const data of this.category.meta_data_definition.properties) {
          data.value = null;
        }
        (window.URL || window.webkitURL).revokeObjectURL(this.filePath)
        this.uploadMessage = true;
        this.toggleUpload = false;
      }),
      error =>{
        this.alertService.error(error);
      }
    }

    // this.documentService.uploadDocument(uploadReq)
    //   .subscribe(
    //     resp => {
    //       this.docId = resp["docId"];
    //       if (resp['storageProvider'] == "AWS") {
    //         if (resp["uploadUrl"].length > 1) {
    //           console.log("Multipart Upload")
    //           var uploadId = null
    //           var key = null
    //           var start = 0
    //           var end = 0
    //           var part = 1.
    //           const noOfParts = resp["uploadUrl"].length
    //           resp["uploadUrl"].forEach(url => {
    //             if (!uploadId || !key) {
    //               var decodedUrl = decodeURIComponent(url)
    //               var splitData = decodedUrl.split('?')[0]
    //               key = splitData.split("aws.com/")[1]
    //               var params = new URLSearchParams(url);
    //               uploadId = params.toString().split("&")[0].split("=")[1]
    //             }
    //             const chunkSize = (5 * 1024 * 1024)
    //             end = start + chunkSize
    //             if (end > this.fileToUpload.size) {
    //               end = this.fileToUpload.size
    //             }
    //             var chunk = this.fileToUpload.slice(start, start + chunkSize + 1)
    //             start = end
    //             this.multiparts = []
    //             this.documentService.uploadToS3(url, chunk).subscribe(resp => {
    //               this.createMultipartHandler(resp).then(() => {
    //                 part++;
    //                 if ((part - 1) == noOfParts && noOfParts == this.multiparts.length) {
    //                   this.multiparts.sort((a, b) => {
    //                     return a.PartNumber - b.PartNumber;
    //                   });
    //                   const request = {
    //                     uploadId: uploadId,
    //                     key: key,
    //                     parts: this.multiparts
    //                   }
    //                   this.documentService.completeMultipartUpload(request).subscribe(respnse => {
    //                     this.documentTitle = null;
    //                     for (const data of this.category.meta_data_definition.properties) {
    //                       data.value = null;
    //                     }
    //                     (window.URL || window.webkitURL).revokeObjectURL(this.filePath)
    //                     this.uploadMessage = true;
    //                     this.toggleUpload = false;
    //                   }
    //                   ,error=>{
    //                     this.documentService.revertUpload(this.docId,1,-1).subscribe(response=>{
    //                       // console.log(response)
    //                     })
    //                   })
    //                 }
    //               })
    //             },error=>{
    //                     this.documentService.revertUpload(this.docId,1,-1).subscribe(response=>{
    //                     // console.log(response)
    //               })
    //             })
                
    //           })
    //         }
    //         else {
    //           console.log("No Multipart")
    //           this.documentService.uploadFileToS3(resp["uploadUrl"][0], this.fileToUpload)
    //             .subscribe(
    //               resp => {
    //                 //reset form
    //                 this.documentTitle = null;
    //                 for (const data of this.category.meta_data_definition.properties) {
    //                   data.value = null;
    //                 }
    //                 (window.URL || window.webkitURL).revokeObjectURL(this.filePath)
    //                 this.uploadMessage = true;
    //                 this.toggleUpload = false;
    //               }
    //               ,error => {
    //                 this.documentService.revertUpload(this.docId,1,-1).subscribe(response=>{
    //                   // console.log(response)
    //             })
    //               }) 
    //         }
    //       } else if (resp['storageProvider'] == "Azure") {
    //         this.azureHeader = resp["azureMetadata"]
    //         this.documentService.uploadFileToAzure(resp["uploadUrl"], this.fileToUpload, this.azureHeader)
    //           .subscribe(
    //             resp => {
    //               //reset form
    //               this.documentTitle = null;
    //               for (const data of this.category.meta_data_definition.properties) {
    //                 data.value = null;
    //               }
    //               (window.URL || window.webkitURL).revokeObjectURL(this.filePath)
    //               this.uploadMessage = true;
    //               this.toggleUpload = false;
    //             }
    //           ),
    //           error => {
    //             this.alertService.error(error);
    //           }
    //       } else if (resp['storageProvider'] == "GCP") {
    //         console.log("GCP response", resp)
    //         this.documentService.uploadFileToGCP(resp["uploadUrl"], this.fileToUpload)
    //           .subscribe(
    //             resp => {
    //               (window.URL || window.webkitURL).revokeObjectURL(this.filePath)
    //               this.uploadMessage = true;
    //               this.toggleUpload = false;
    //             }
    //           ),
    //           error => {
    //             this.alertService.error(error);
    //           }
    //       }
    //       else {
    //         alert("Invalid Storage Provider! Please try again.")
    //       }
    //     }),
    //   error => {
    //     this.alertService.error(error);
    //   }
  }

  validData() {
    return new Promise((resolve, reject) => {
      var isValidData = true;
      if (this.properties["Placeholder UUID"] && this.properties["Placeholder UUID"] != "" && !this.properties["Placeholder UUID"].includes("PLCHD")) {
        isValidData = false;
      }
      resolve(isValidData)
    });
  }

  createMultipartHandler(response) {
    return new Promise<void>((resolve, reject) => {
      var params = new URLSearchParams(response.url);
      var part = params.get("partNumber")
      var Etag = response.headers.get("ETag")
      var obj = { ETag: Etag, PartNumber: parseInt(part) }
      this.multiparts.push(obj)
      resolve()
    })
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onClose(): void {
    (window.URL || window.webkitURL).revokeObjectURL(this.filePath)
    this.openUpload.emit(false)
  }

  makeOptions = () => new JsonEditorOptions();
}